<template>
  <router-view/>
</template>

<script>
export default {
  name: "App",
  components : {

  }
}
</script>


<style>
html {
  background-color: var(--bs-gray-900);
}

body {
  background-color: var(--bs-gray-900);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #d6e1ff;
  margin: 0px auto;
  max-width: 70rem;
}
</style>
